import { BehaviorSubject, Subject, from } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import APIResponse from '../models/APIResponse';
import getInlineHelpContentService from '../services/inlineHelpContent';

export interface InlineHelpContentPayload {
  pageId: string;
}

export interface InlineHelpContentOutput {
  inlineHelpContent: string;
}

export type FetchInlineHelpContentAPIResponse = APIResponse<InlineHelpContentOutput, any>;

export const inlineHelpContentAction$ = new Subject<InlineHelpContentPayload>();
const inlineHelpContentPayloadStore$ = new BehaviorSubject<InlineHelpContentPayload>({
  pageId: ''
});
export const inlineHelpContentStore$ = new BehaviorSubject<FetchInlineHelpContentAPIResponse>({});
inlineHelpContentAction$.subscribe(inlineHelpContentPayloadStore$);
inlineHelpContentAction$.pipe(
  switchMap(({pageId}) => getInlineHelpContentService({pageId}).pipe(
    map(({inlineHelpContent}) => ({
      response: inlineHelpContent
    })),
    catchError(err => from([{
      error: err
    }]))
  ))
).subscribe(inlineHelpContentStore$);

export function resetContentStore() {
  inlineHelpContentStore$.next({});
}

inlineHelpContentStore$.subscribe(({error}) => {
  if (!error) {
    // eslint-disable-next-line no-useless-return
    return;
  }
  // TODO: implement notification for failed request
});
